<div class="srp-toggle-container" [class.d-none]="srpDisplayed !== undefined && !srpDisplayed">
  <div class="srp-toggle-container">
    <mat-slide-toggle
      [checked]="srpToggleValue"
      (change)="onChangeSrpToggle($event)"
      [disabled]="disabled"
      class="js-header-srp-toggle"
    ></mat-slide-toggle>
  </div>
</div>
